import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Top = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Column = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`;
